import { Stack, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { convertsCentsToCurrency } from '@npi/buddy-utils';
import { Dayjs } from 'dayjs';

import { Spacer } from 'src/components';
import { DropDown, FieldInput } from 'src/components/FormikComponents';
import CustomDatePicker from 'src/components/NPIDateRangePicker/CustomDatePicker';

interface AllocatePaymentModalContentProps {
    readonly usersCurrency: string;
    readonly totalOutstanding: number;
    readonly allocating: boolean;
    readonly status: string;
    readonly paymentMethods: {
        value: string;
        label: string;
    }[];
    readonly maxDate: Dayjs;
    readonly dateValue: Dayjs;
    readonly dateError: string;
    readonly updateDate: (newDate: Dayjs) => void;
}

function AllocatePaymentModalContent({
    usersCurrency,
    totalOutstanding,
    allocating,
    status,
    paymentMethods,
    maxDate,
    dateValue,
    dateError,
    updateDate,
}: AllocatePaymentModalContentProps) {
    return (
        <Stack width="100%" flexDirection="column" spacing={2}>
            <Stack
                width="100%"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Stack flexDirection="row">
                    <Typography fontWeight="600">Status</Typography>
                    <Spacer padding={1} />
                    <Typography>{status?.replace(/_/g, ' ')}</Typography>
                </Stack>
                <Stack flexDirection="row">
                    <Typography fontWeight="600">Invoice Amount Outstanding</Typography>
                    <Spacer padding={1} />
                    <Typography>
                        {usersCurrency} {convertsCentsToCurrency(totalOutstanding).toFixed(2)}
                    </Typography>
                </Stack>
            </Stack>

            <DropDown
                name="paymentMethod"
                options={paymentMethods}
                label="Method"
                placeholder="Method"
                disabled={allocating}
            />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack>
                    <CustomDatePicker
                        label="Date"
                        onChange={(newDate) => {
                            updateDate(newDate);
                        }}
                        maxDate={maxDate}
                        value={dateValue}
                        disableFuture={allocating}
                    />
                    {dateError && <label className="error">{dateError}</label>}
                </Stack>
            </LocalizationProvider>

            <FieldInput name="paymentAmount" label="Amount" type="number" />
        </Stack>
    );
}
export default AllocatePaymentModalContent;
